<div class="card mb-5">
    <div class="card-header">
		<h3>Certificado de Análisis 
            <span (click)="createCoa = true;">
                <i style="font-size: 0.8em;" class="a-hover fa fa-plus">
                    <span style="font-family: 'Nunito', sans-serif;">CREAR CERTIFICADO DE ANÁLISIS</span>
                </i>
            </span>
        </h3>
	</div>
    <div class="card-body">
        <div class="row">
            <div class="col" id="list-container">
                <div class="row" id="options-other-filters">
					<div class="col-sm form-group">
						<label for="filterVendors" class="form-label">Filtrar</label>
						<div class="input-group input-group-sm">
							<input type="text" id="filter" [(ngModel)]="filterWord"
								placeholder="Filtra producto por numero" (input)="searching()" name="filter" class="form-control">
							<button class="btn btn-primary" (click)="searching()">
								<i class="fa fa-search"></i>
							</button>
						</div>
					</div>
				</div>
                <div class="table-responsive" style="margin-bottom: 0;">
                    <table class="table table-bordered" style="margin-bottom: 0; margin-top: 1em;" *ngIf="!loadingData">
                        <thead>
							<tr>
								<th class="ta">
									Número
								</th>
								<th class="ta">
									Código
								</th>
								<th class="ta">
									Lote
								</th>
								<th class="ta">
									Producto
								</th>
                                <th class="ta">
									Fecha
								</th>
								<th class="text-center">
									Acciones
								</th>
							</tr>
						</thead>
                        <tbody>
                            <ng-container *ngFor="let item of pagination.filter">
                                <tr>
                                    <td class="ta">{{item.number}}</td>
                                    <td class="ta">{{item.code}}</td>
                                    <td class="ta">{{item.batch}}</td>
                                    <td class="ta">
                                        <div class="d-flex flex-col text-truncate" *ngIf="item.productData">
                                            <span class="font-bold text-truncate">{{item.productData.name ?? ""}}</span>
                                            <span class="font-regular text-truncate">{{item.productData.code ?? ""}}</span>
                                        </div>
                                    </td>
                                    <td class="ta">{{item.date | date:'dd-MM-YYYY'}}</td>
                                    <td class="text-center">
                                        <span class="a-hover text-primary" (click)="showDetails(item)"><i class="fa fa-eye"></i></span>
                                        <span (click)="downloadCOA(item)" class="download-receipt ml-2" tooltip="Descargar">
                                            <i class="clickeable text-info fa fa-receipt span-hover text-primary"></i>
                                        </span>
                                        <span class="a-hover text-danger ml-2" (click)="deleteCoa(item)"><i class="fa fa-trash"></i></span>
                                    </td>
                                </tr>
                            </ng-container>
                        </tbody>
                    </table>
                    <div class="relative-graph" style="min-height: 350px;" *ngIf="loadingData">
                        <div class="absolute-loading" *ngIf="loadingData">
                            <span class="display-5 text-center">
                                <app-loading-animation [height]="'3rem'"></app-loading-animation>
                                Cargando...
                            </span>
                        </div>
                        <div class="absolute-loading" *ngIf="!loadingData && pagination.filter.length == 0">
                            <span class="display-5 text-center">
                                <div class="empty-icon-container">
                                    <div class="empty-icon-animation">
                                        <i class="fa-solid fa-exclamation"></i>
                                    </div>
                                    <i class="fa fa-list"></i>
                                </div>
                                No se cuenta con registros
                            </span>
                        </div>
                    </div>
                </div>
                <app-pagination-custom [elements]="pagination"></app-pagination-custom>
            </div>
        </div>
    </div>
</div>

<app-create-coa *ngIf="createCoa" [showModal]="createCoa" (closed)="closeCreateCoa($event)"/>

<app-coa-details
    *ngIf="showDetailsId != null"
    [showModal]="showDetailsId != null"
    [coaId]="showDetailsId"
    (closed)="closeDetails()"
></app-coa-details>